// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__KoN6Z","row":"ProcedureTreatmentSummary_row__2rsNy"};